/**
 * @Description 抽屉
 */
import { FC, MutableRefObject, forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react';
import V2Drawer, { V2DrawerHandles } from 'src/common/components/Feedback/V2Drawer/index';
import Detail from './Detail';
import UserInfoContext from '@/layout/context';
import { globalFranchiseeAlias } from '@/common/utils/ways';

const ExpansionFranchiseeCircleTaskEditDrawer:FC<any> = forwardRef(({
  reload,
  onClose,
  businessInfo,
  isBusiness,
  franchiseeId, // isFromFranchisee时用
  isFromFranchisee = false, // 从加盟商列表过来
}, ref) => {
  useImperativeHandle(ref, () => ({
    init
  }));

  const [open, setOpen] = useState(false); // 弹出框是否打开
  const drawerWrapper: MutableRefObject<V2DrawerHandles | null> = useRef(null);
  const detail: any = useRef();
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  const franchiseeAlias = globalFranchiseeAlias(globalAliasItemVOs);

  const init = () => {
    setOpen(true);

    setTimeout(() => {
      drawerWrapper.current?.getBodyElement().scrollTo({ top: 0 });
      detail.current.init instanceof Function && detail.current.init();
    }, 0);
  };

  const [container, setContainer] = useState<HTMLElement | null>(null);
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        const target = drawerWrapper.current?.getBodyElement();
        target && setContainer(target);
      }, 0);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <V2Drawer
      onRef={drawerWrapper}
      open={open}
      onClose={handleClose}
      maskClosable={false}
      push={false}>
      {open && <Detail
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        franchiseeId={franchiseeId}
        isFromFranchisee={isFromFranchisee}
        reload={reload}
        ref={detail}
        container={container}
        onClose={handleClose}
        franchiseeAlias={franchiseeAlias}/>}
    </V2Drawer>
  );
});

export default ExpansionFranchiseeCircleTaskEditDrawer;
